<template>
  <eden-confirm-dialog
    :title="'Delete Rider'"
    :button-text="'Delete'"
    :button-type="'danger'"
    :button-status.sync="deleting"
    :show.sync="setShow"
    @confirm="deleteRider"
  >
    <p>
      This action cannot be undone. Are you sure you want to delete this rider?
    </p>
  </eden-confirm-dialog>
</template>

<script>
import riders from "@/requests/marketplace-logistics/riders";

export default {
  name: "RiderDelete",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    riderId: String,
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    deleteRider() {
      this.deleting = true;
      riders
        .delete(this.riderId)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.$emit("success");
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        })
        .finally(() => {
          this.close();
        });
    },
    close() {
      this.setShow = false;
      this.deleting = false;
    },
  },
};
</script>
